export function formatTime(time24) {
    let [h, m] = time24.split(":").map(Number);
    const ampm = h >= 12 ? "PM" : "AM";
    h = h % 12 || 12;
    return `${h}:${m.toString().padStart(2, "0")} ${ampm}`;
}

export const formatPhone = (value) => {
    const digits = value.replace(/\D/g, "").slice(0, 10);
    const match = digits.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
    if (!match) return value;
    return [match[1], match[2], match[3]].filter(Boolean).join("-");
};

export const formatMoney = (num) => {
    const f = new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN',
        minimumFractionDigits: 2
    }).format(num);

    return f.replace('$', '$ ');
}

export const paymentHistoryFormat = async (response) => {
    let paymentHistory = [];
    // Iteramos sobre cada pago en la respuesta
    await response.forEach(v => {
        let concepts = v.payment_detail.concepts.map(concept => concept.name);
        let amounts = v.payment_detail.concepts.map(concept => parseFloat(concept.amount));
        let combinedConcepts = {};
        let conceptWeeks = {}; // Para almacenar las semanas por concepto
        let conceptStatus = {}; // Para almacenar las semanas por concepto
        concepts.forEach((concept, index) => {
            if (combinedConcepts[concept]) {
                combinedConcepts[concept] += amounts[index];
                conceptWeeks[concept].push(v.payment_detail.concepts[index].week);
                conceptStatus[concept] = v.payment_detail.concepts[index].concept_st;
            } else {
                combinedConcepts[concept] = amounts[index];
                conceptWeeks[concept] = [v.payment_detail.concepts[index].week];
                conceptStatus[concept] = v.payment_detail.concepts[index].concept_st;

            }
        });
        // Creamos una lista de conceptos combinados y sus montos sumados
        let newConcept = Object.keys(combinedConcepts).join(", ");
        let newAmount = Object.values(combinedConcepts).join(", ");

        // Calculamos el porcentaje pagado por concepto
        let conceptPercentages = {};
        Object.keys(conceptWeeks).forEach(concept => {
            const weeks = conceptWeeks[concept];
            const totalPercentPaid = weeks.reduce((total, week) => {
                const weekData = v.payment_detail.concepts.find(c => c.week === week);
                return total + (weekData ? parseFloat(weekData.week.percent_paid) : 0);
            }, 0);
            const avgPercentPaid = weeks.length > 0 ? totalPercentPaid / weeks.length : 0;

            // Si el porcentaje es NaN o no se puede calcular, asignamos "No Aplica"
            conceptPercentages[concept] = isNaN(avgPercentPaid) ? "No Aplica" : `${avgPercentPaid.toFixed(2)}%`;
        });
        let object = {
            receipt_id: v.id,
            students: v.students || [],
            is_shared: v.is_shared,
            receipt_date: v.date_time,
            concept: newConcept,
            concept_st: conceptStatus,
            cash_audit_id: v.cash_audit_id,
            payedWeeks: v.payment_detail.concepts
                .filter(concept =>
                    (concept.name === 'Abono' || concept.name === 'Colegiatura') &&
                    concept.week &&
                    concept.week.week &&
                    concept.week.year
                )
                .map(concept => ({
                    weekNumber: parseInt(concept.week.week),
                    year: parseInt(concept.week.year),
                    week: `${concept.week.week}-${concept.week.year}`,
                    percent_paid: concept.week.percent_paid,
                    paid_is_active: concept.week.paid_is_active
                }))
                .sort((a, b) => {
                    // Primero por año, luego por número de semana
                    if (a.year !== b.year) {
                        return a.year - b.year;
                    }
                    return a.weekNumber - b.weekNumber;
                })
                .map(({ week, percent_paid, paid_is_active }) => ({ week, percent_paid, paid_is_active })),

            amount: newAmount,
            conceptPercentages: conceptPercentages, // Almacenamos los porcentajes por concepto
            st: v.st,
            total_payed_amount: v.total_payed_amount,
            payment_method: v.payment_method,
            exchange_rates: v.exchange_rates,
            refund_status: v.refund_status,
            cancelled_at: v.cancelled_at,
            cancelled_by: v.cancelled_by,
            cancel_reason: v.cancel_reason
        };
        paymentHistory.push(object);
    });
    return paymentHistory;
};

const daysOrder = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];

export function compressDays(input) {
    if (!input) return "";

    const days = Array.isArray(input)
        ? input
        : input.split(",");

    const normalizedOrder = daysOrder.map(d => d.toLowerCase());

    const indices = days
        .map(d => normalizedOrder.indexOf(d.trim().toLowerCase()))
        .filter(i => i !== -1)
        .sort((a, b) => a - b);

    if (indices.length === 0) return "";

    let result = [];
    let temp = [indices[0]];

    for (let i = 1; i < indices.length; i++) {
        if (indices[i] === indices[i - 1] + 1) {
            temp.push(indices[i]);
        } else {
            result.push(formatRange(temp));
            temp = [indices[i]];
        }
    }

    result.push(formatRange(temp));

    return result.join(", ");
}

function formatRange(indices) {
    if (indices.length > 1) {
        return `${daysOrder[indices[0]]}-${daysOrder[indices[indices.length - 1]]}`;
    }
    return daysOrder[indices[0]];
}